module.exports = __webpack_public_path__ + "assets/img/news (35).776759a2.png";